import { useParams } from 'react-router-dom'
import { gql, useQuery } from '@apollo/client'
import { getGroupUrl } from 'helpers'

import NotFound from 'js/core/NotFound'
import { genericArticleViewFragment } from 'js/genericArticle/fragments/genericArticleEntity'

import ItemLayout from './components/ItemLayout'

const Detail = () => {
    const params = useParams()
    const { guid, groupGuid } = params

    const { loading, data } = useQuery(GET_GENERIC_ARTICLE, {
        variables: {
            guid,
            groupGuid,
        },
    })

    const { data: viewerData, loading: viewerLoading } = useQuery(
        GET_VIEWER_RIGHTS,
        {
            variables: {
                subtype: data?.entity?.contentType?.key || '',
                groupGuid: data?.entity?.group?.guid || '',
            },
            skip: !data?.entity,
        },
    )

    if (loading || viewerLoading) return null
    if (!data || !data.entity || !viewerData) return <NotFound />

    const { entity } = data
    const { contentType } = entity
    const { slug, formFields, hasFeaturedImage } = contentType

    const { detailViewTemplateIds } = contentType

    const onEdit = `${getGroupUrl(params)}/${slug}/edit/${guid}`
    const onAfterDelete = `${getGroupUrl(params)}/`

    return (
        <ItemLayout
            viewer={viewerData?.viewer}
            entity={{
                ...entity,
                // If showFeatured is disabled in admin, we should remove the possible featured image from the entity
                featured: hasFeaturedImage ? entity.featured : {},
            }}
            onEdit={onEdit}
            onAfterDelete={onAfterDelete}
            options={{
                author: detailViewTemplateIds.includes('author'),
                publishDate: detailViewTemplateIds.includes('publishDate'),
                views: detailViewTemplateIds.includes('views'),
                save: detailViewTemplateIds.includes('save'),
                likes: detailViewTemplateIds.includes('likes'),
                follow: detailViewTemplateIds.includes('follow'),
                share: detailViewTemplateIds.includes('share'),
                comments: detailViewTemplateIds.includes('comments'),
            }}
            formFields={formFields}
            {...({} as any)}
        />
    )
}

const GET_GENERIC_ARTICLE = gql`
    query GetGenericArticle($guid: String!, $groupGuid: String) {
        entity(guid: $guid, incrementViewCount: true) {
            ${genericArticleViewFragment}
        }
    }
`

const GET_VIEWER_RIGHTS = gql`
    query GetViewerRights($subtype: String!, $groupGuid: String!) {
        viewer {
            guid
            loggedIn
            user {
                guid
                name
                icon
            }
            canInsertMedia(subtype: $subtype)
            requiresCommentModeration(subtype: $subtype, groupGuid: $groupGuid)
        }
    }
`

export default Detail
